import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ArrowLeftIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Arrow Left`} {...props}>
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 14L1 8l6-6M2 8h13"
      fill="none"
    />
  </Icon>
);
